module.exports = __webpack_public_path__ + "static/media/SDFSA_4-509w.3c0aeb58.webp";